var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNextIcon = function SvgNextIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M14.489 10.009c0 .419-.18.778-.48 1.018l-6.707 5.929c-.48.42-1.198.36-1.557-.12-.36-.479-.36-1.138.12-1.557l5.868-5.15c.06-.06.06-.12 0-.24l-5.869-5.15a1.07 1.07 0 0 1-.06-1.558 1.19 1.19 0 0 1 1.558-.12l6.707 5.87c.24.3.42.658.42 1.078"
  })));
};
export { SvgNextIcon as ReactComponent };